module.exports = __webpack_public_path__ + "img/fun1.f625f417.png";